import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-main-user',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './main-user.component.html',
  styleUrl: './main-user.component.css',
})
export class MainUserComponent {
  institucion: any;
  codigo: string = '';
  nombre: string = '';
  options = [
    {
      name: 'Documentos',
      icon: 'fas fa-file-alt',
      route: '/documentos-institucion',
    },
  ];
  constructor(private router: Router) {}
  ngOnInit() {
    if (typeof window !== 'undefined' && window.localStorage) {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        this.institucion = JSON.parse(storedUser);
        //console.log(this.institucion);
        this.codigo = this.institucion?.cod_mod ?? '';
        this.nombre = this.institucion?.cen_edu ?? '';
      } else {
        // console.log('No hay usuario en localStorage, redirigiendo al login...');
        this.router.navigate(['/login']);
      }
    } else {
      // console.log('localStorage no está disponible en este entorno');
    }
  }
  navigateTo(route: string): void {
    this.router.navigate([route]);
  }
  logout(): void {
    // Elimina el usuario del localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    // Redirige al usuario a la página de inicio (home)
    this.router.navigate(['/home']);
  }
}
